"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAxiosErrorHandling = addAxiosErrorHandling;

var _index = _interopRequireDefault(require("axios/index"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function addAxiosErrorHandling() {
  var axiosClient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _index["default"];
  var sentryCookieName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sentry_id';
  var loginUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/login/';
  axiosClient.interceptors.response.use(undefined, function (error) {
    if (error === undefined) {
      return new Promise(function () {});
    } else if (_index["default"].isCancel(error)) {
      return Promise.reject(error);
    } else if (error.response === undefined) {
      if (error.message !== undefined) {
        setTimeout(function () {
          alert('Could not connect to server: ' + error.message + '\nTry refreshing the page.');
        }, 1000);
      }
    } else if (error.response.status === 403 || error.response.status === 401) {
      document.location = "".concat(loginUrl, "?next=").concat(document.location.pathname);
    } else if (error.response.status === 404) {
      document.location = '/404/';
    } else if (error.response.status === 500) {
      var sentry_id = _jsCookie["default"].get(sentryCookieName);

      if (sentry_id && Sentry !== undefined) {
        Sentry.showReportDialog({
          eventId: sentry_id
        });

        _jsCookie["default"].remove(sentryCookieName);
      } else {
        setTimeout(function () {
          alert('An error occurred: ' + error.response.statusText);
        }, 100);
      }
    } else {
      return Promise.reject(error);
    }

    return new Promise(function () {});
  });
}